export class ValidationError extends Error {
  public errors: string[];

  constructor(errors: string[]) {
    super(errors.join('\n'));
    this.name = 'ValidatorError';
    this.errors = errors;
  }
}
